module.exports = __webpack_public_path__ + "img/colored-rounded.dc4cbb40.svg";